import {
  Button,
  Modal,
  TextLink,
} from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

const AEGIS_MIGRATION_GUIDE_URL =
  "https://support.id.x.moneyforward.com/hc/ja/articles/54935707295257";

const overlay = css({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 20,
});

type Props = {
  active: boolean;
  onClickMigrate: () => void;
  onClickLater: () => void;
};

export const MigratePromptModal = ({
  active,
  onClickMigrate,
  onClickLater,
}: Props) => {
  if (!active) return <></>;

  const body = (
    <div>
      <p>
        セキュリティ向上と機能改善のため、すべてのユーザーアカウントを最新システムへのアップグレードをお願いいたします。
      </p>
      <p>
        移行する処理は数秒で完了し、現在の設定やデータはすべて維持されます。
      </p>
      <TextLink href={AEGIS_MIGRATION_GUIDE_URL} target="_blank">
        最新システムへの移行について
      </TextLink>
    </div>
  );

  const footerButtons = (
    <>
      <Button variant="secondary" onClick={onClickLater}>
        また次回
      </Button>
      <Button variant="primary" onClick={onClickMigrate}>
        移行する
      </Button>
    </>
  );

  return (
    <div css={overlay}>
      <Modal
        title="最新システムへ移行してください"
        body={body}
        zIndex={21}
        footerButtons={footerButtons}
        onClose={onClickLater}
      />
    </div>
  );
};
